// Updated Projects Data
// Note: Projects will eventually be fetched from an API in a different setup.

const projects = [
  {
    id: 4,
    title: "KwaraTech Project",
    stack: ["Next project"],
    category: "Innovative Educational Platform",
    img: require("@/assets/images/kwaratech.png"),
    url: "https://kwaratech.vercel.app/",
  },
  {
    id: 5,
    title: "Buzz Chat App",
    stack: ["React project"],
    category: "Real-Time Messaging App",
    img: require("@/assets/images/buzz.png"),
    url: "https://buzzz.vercel.app/",
  },
  {
    id: 6,
    title: "Juva Healthcare",
    stack: ["React project"],
    category: "Telemedicine Platform UI",
    img: require("@/assets/images/juva.png"),
    url: "https://juva.netlify.app/",
  },
  {
    id: 7,
    title: "Workonnet Dashboard",
    stack: ["Nuxt project"],
    category: "Job Seeker and Recruiter Platform",
    img: require("@/assets/images/workonnet.png"),
    url: "https://workonnect.africa/",
  },
  {
    id: 8,
    title: "Admin Panel",
    stack: ["Vue project"],
    category: "Admin Dashboard Interface",
    img: require("@/assets/images/admin.png"),
    url: "https://paradido.netlify.app/dashboard/child-minder/home",
  },
  {
    id: 9,
    title: "Kampus Hub",
    stack: ["Next project"],
    category: "Student Resource Portal",
    img: require("@/assets/images/kampus.png"),
    url: "https://kampusly.netlify.app/",
  },
  {
    id: 10,
    title: "Paradido landing-page",
    stack: ["Vue project"],
    category: "child-minder and business platform",
    img: require("@/assets/images/landing-page.png"),
    url: "https://paradido.netlify.app/",
  },
  {
    id: 11,
    title: "Paradido business-page",
    stack: ["Nuxt project"],
    category: "Paradido business Portal",
    img: require("@/assets/images/business-page.png"),
    url: "https://paradido.netlify.app/auth/create-business",
  },
  {
    id: 12,
    title: "Paradido logins",
    stack: ["Nuxt project"],
    category: "Paradido login Portal",
    img: require("@/assets/images/login.png"),
    url: "https:/https://paradido.netlify.app/auth/login",
  },
];

export default projects;
